import { PieChart, Pie, Legend, Cell } from "recharts";
import { getRandomColor } from "../../../helpers/helper";
import { getGraphDetails } from "./ChartUtils";
import Heading from "../../atoms/Heading";
import { Tooltip } from "antd";

// #endregion
export const CustomPieChart = ({ chartData, seriesMap, compact = true }) => {
  const [xDataKey, yDataKeys, data] = getGraphDetails(chartData, seriesMap);
  const COLORS = data.map(() => getRandomColor());
  return (
    <PieChart
      style={{ width: compact ? 120 : "100%", height: 90, aspectRatio: 1 }}
      responsive
      margin={{ top: 0, right: 10, bottom: 0, left: 0 }}
    >
      <Pie
        data={data}
        dataKey={yDataKeys[0]}
        nameKey={xDataKey}
        cx="50%"
        cy="50%"
        outerRadius="50%"
        label
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index]} />
        ))}
      </Pie>
      <Legend
        iconType="circle"
        iconSize={compact ? 6 : 14} // tiny circle
        wrapperStyle={
          compact
            ? {
                fontSize: "10px", // xx-small
                paddingTop: "4px",
              }
            : {}
        }
      />
    </PieChart>
  );
};

export default CustomPieChart;
